export enum EPath {
  HOME = "/*",
  BROKER = "/reference/broker",
  CREATE_BROKER = "/reference/broker/create",
  LOGIN = "/login",
  SIGN_UP = "/sign-up",
  ONBOARDING = "/onboarding",
  PATIENT_MANAGEMENT = "/patient-management",
  PATIENT_DASHBOARD = "/patient/:patientId",
  ADD_PATIENT = "/patients/add",
  APPOINTMENT = "/appointment",
  APPOINTMENT_SETTINGS = "/appointment/settings",
  PRACTICE_MANAGEMENT = "/practice-management",
  PRACTICE_DETAIL = "/practice/:practiceId",
  PRACTICE_PROFILE = "/practice-profile",
  INVITE_PRACTICE = "/practice/invite",
  PROFILE = "/profile",
  FORGOT_PASSWORD = "/forgot-password",
  RESET_PASSWORD = "/reset-password",
  SETTINGS_RESET_PASSWORD = "/settings/reset-password",
  AUTH_ACTION = "/__/auth/action",
  NUTRITION_HYDRATION = "/nutrition-hydration/:patientId",
  REPRODUCTIVE_HEALTH = "/profile/reproductive-health/:patientId",
  DAILY_WELL_BEING_SCORE = "/profile/daily-well-being-score/:patientId/year/:lastYearChecked/month/:lastMonthChecked",
  ACTIVITY = "/activity/:patientId",
  SLEEP = "/sleep/:patientId",
  HEART_METRICS = "/heart-metrics/:patientId",
  PRACTICE_SUBSCRIPTION = "/practice/subscription",
  PAYMENT_MANAGEMENT = "/payment-management",
  ROLE_MANAGEMENT = "/admin/role-management",
  BODY_MEASUREMENTS = "/body-measurements/:patientId",
  WEARABLES = "/wearables/:patientId",
  PRESCRIPTIONS = "/prescriptions/:patientId",
  TREATMENT_PLAN = "/treatment-plan",
  PERSONALIZED_WELLNESS_PROTOCOL = "/treatment-plan/goals",
  GENERATED_PROTOCOL_RESULT = "/treatment-plan/generated-result/:patientId/:treatmentId",
  PRESCRIPTION_MANAGEMENT = "/prescription-management",
  PRESCRIPTION_DETAIL = "/prescription/:prescriptionId",
  COMMUNICATIONS = "/communications",
  PRESCRIPTION_CREATE = "/prescription/create",
  PRACTICE_CONFIGURATION = "/practice-configuration",
  LEARNING_CERTIFICATION = "/learning-certification",
  PAYMENT_SUCCESSFUL = "/payment-successful",
  ADD_SERVICE = "/add-service",
  UNAUTHORIZED = "/unauthorized",
  APP_REDIRECT = "/app/*",
  INSTRUCTION_GENERATION = "/instruction-generation",
  PROCEDURE_GENERATION = "/procedure-generation",
  RXNT_CLOSE = "/rxnt/close",
  EFAX = "/efax",
  PAST_DUE_SUBSCRIPTION = "/subscription-past-due",
}
